import React from "react";
import PropTypes from "prop-types";
import AttendanceDecisionRow from "./AttendanceDecisionRow";

function AttendanceDecisionList({
  participants,
  decisions,
  invalidStudentIds,
  lessonDetails,
  canEdit,
  onDecisionChange,
}) {
  return (
    <div className="attendance-page__list">
      {participants.map(student => (
        <AttendanceDecisionRow
          key={student.id}
          student={student}
          decision={decisions[student.id]}
          invalid={invalidStudentIds.includes(student.id)}
          lessonDetails={lessonDetails}
          canEdit={canEdit}
          onDecisionChange={onDecisionChange}
        />
      ))}
    </div>
  );
}

AttendanceDecisionList.propTypes = {
  participants: PropTypes.array.isRequired,
  decisions: PropTypes.object.isRequired,
  invalidStudentIds: PropTypes.array,
  lessonDetails: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
  onDecisionChange: PropTypes.func.isRequired,
};

AttendanceDecisionList.defaultProps = {
  invalidStudentIds: [],
};

export default AttendanceDecisionList;
